import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';

import { useIntl } from 'react-intl';

import { TagsFilter } from '@components/molecules/TagsFilter';

import dropdownArrow from 'images/dropdown-arrow.svg';

import { realizationMsg } from '../../../../intl';

import * as S from './styles';
import { IProjectFilterProps } from './types';

export const ProjectFilter: React.FC<IProjectFilterProps> = ({
  onAttributeFiltersChange,
  clearFilters,
  attributes,
  filters,
}) => {
  const intl = useIntl();
  const [filterKey, setFilterKey] = useState<string | null>(null);

  const toggleFilter = (key: string) => {
    const val = key === filterKey ? null : key;
    setFilterKey(val);
  };

  const hasFilters = (): boolean => filters.attributes !== undefined;

  const withSelected = (
    slug: string,
    attributeSlug: string
  ): Array<{
    id: string;
    name: string;
    slug: string;
    selected: boolean;
    url?: string;
    color?: string;
  }> => {
    const filterItem = attributes.find((z) => z.slug === slug);
    if (filterItem) {
      return filterItem.values.map((z) => {
        let selected = false;
        if (filters.attributes && attributeSlug in filters.attributes) {
          selected = filters.attributes[attributeSlug].some(
            (filter) => filter === z.slug
          );
        }
        return {
          ...z,
          selected,
        };
      });
    }
    return [];
  };

  const hasActiveFilter = (key): boolean =>
    withSelected(key, key).some((z) => z.selected);

  return (
    <S.Wrapper className="project-filter">
      <S.Header className="filter-header">
        <S.Item
          className={`
              ${'filter-item'}
              ${filterKey === 'category' ? 'active' : ''}
              ${hasActiveFilter('category') ? 'selected' : ''}`}
          onClick={() => toggleFilter('category')}
          aria-hidden="true"
        >
          {intl.formatMessage(realizationMsg.category)}
          <ReactSVG className="dropdown-arrow" src={dropdownArrow} />
        </S.Item>
        <S.Item
          className={`
              ${'filter-item'}
              ${filterKey === 'tag' ? 'active' : ''}
              ${hasActiveFilter('tag') ? 'selected' : ''}`}
          onClick={() => toggleFilter('tag')}
          aria-hidden="true"
        >
          {intl.formatMessage(realizationMsg.tags)}
          <ReactSVG className="dropdown-arrow" src={dropdownArrow} />
        </S.Item>
        {hasFilters() && (
          <S.ResetButton
            className="filter-reset"
            onClick={clearFilters}
            aria-hidden="true"
          >
            {intl.formatMessage(realizationMsg.clear_filter)}
          </S.ResetButton>
        )}
      </S.Header>
      {filterKey && (
        <S.Body className={`filter-body ${filterKey || ''}`}>
          {filterKey === 'category' && (
            <TagsFilter
              name="category"
              values={withSelected('category', 'category')}
              onValueClick={(value) =>
                onAttributeFiltersChange('category', value.slug)
              }
            />
          )}
          {filterKey === 'tag' && (
            <TagsFilter
              name="tag"
              values={withSelected('tag', 'tag')}
              onValueClick={(value) =>
                onAttributeFiltersChange('tag', value.slug)
              }
            />
          )}
        </S.Body>
      )}
      {hasFilters() && (
        <S.ResetButton
          className="filter-reset"
          onClick={clearFilters}
          aria-hidden="true"
        >
          {intl.formatMessage(realizationMsg.clear_filter)}
        </S.ResetButton>
      )}
    </S.Wrapper>
  );
};
